<template>
	<div>
		<div v-if="loading">
                        <div style="position: fixed; top:0; bottom:0; width:100%;background-color:#efefef;opacity:0.4;z-index:99;margin: 0 auto;text-align:center;">
            <img style="position:relative;top:45%;opacity:1;z-index:100;" :src="'/images/loader.gif'" alt="" />
            </div>
        </div>
<div class="cl"></div>
<div class="trade-sec">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="home-tit">
          <h2><span>Extruder Machine</span></h2>
  <div class="container">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
          <input type="text" v-model="keyword" v-on:input="searchProduct" name="search" class="form-control" placeholder="search e.g. Company Location Size">
      </div>
      <!-- <div class="col-md-1"><button @click="searchProduct()" class="btn btn-success">Search</button></div> -->
      <div class="col-md-2"></div>
    </div>
  </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="extruderMachines.length">
      <div class="col-md-3" v-for="(extruderMachine , index) in extruderMachines" v-bind:key="index">
        <div class="grid-item" v-if="extruderMachine">
          <div class="imgholder ">
            <a @click="viewProduct(extruderMachine.id)">
              <img :src="imgPath+extruderMachine.image1">
            </a>
          </div>
          <div class="product_footer">
            <div class="grid_product_header">
              <span class="name">{{ extruderMachine.sellercompany_name }}  </span>
              <div class="product-location-grid">{{ extruderMachine.city }} , 
             <span v-if="extruderMachine.country"> {{ extruderMachine.country.name }} 
             </span>
              </div>
            </div>
            <div class="product_footer-info">
              <div class="product-price-grid">{{ extruderMachine.extrusion_capacity }} Kg/Hr</div>
              <div>{{ extruderMachine.machine_type }}</div>
            </div>
          </div>
        </div>
        <div v-else>Record Not Found</div>
      </div>
    </div>
    <div v-else><center><b>No Data Found</b></center></div>
  </div>
</div>
<div class="cl"></div>
	</div>
</template>
<script>
export default {
	data() {
        return {
            extruderMachines: [],
            imgPath: process.env.VUE_APP_API_URL,
            loading: false,
            param : '',
            keyword : null
        }
    },
    created() {
        this.loading = true
        this.axios
        .get(process.env.VUE_APP_API_URL+"api/extruder-machine-list?type="+sessionStorage.getItem("machineType"))
          .then(response => {
            this.extruderMachines = response.data.extruder_machine;
        })
        .finally(() => this.loading = false);
        
    },
    methods: {
            viewProduct(id) {
              sessionStorage.setItem("extruderMachine", id);
              this.$router.push({ name: "ExtruderMachineDetails" });
            },
            searchProduct() {
              this.loading = true
              this.axios
              .get(process.env.VUE_APP_API_URL+"api/extruder-machine-search?keyword="+this.keyword)
                .then(response => {
                  this.extruderMachines = response.data.extruder_machine;
              })
              .finally(() => this.loading = false);
            }
        }
};
</script>

<style>
  #exzoom {
    width: 460px;
  }
  .hidden { display: none; }
</style>